var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "mr-t-10" }, [
        _c("fieldset", { staticClass: "border" }, [
          _c("legend", { staticClass: "border" }, [_vm._v("通知設定")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("form", { attrs: { "data-vv-scope": "setting-form" } }, [
            _c("div", { staticClass: "form-group flexbox" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "flex-item flex-input" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("setting-form.noticeEmail"),
                        expression: "errors.has('setting-form.noticeEmail')"
                      }
                    ],
                    staticClass: "text-danger",
                    staticStyle: { display: "block" }
                  },
                  [
                    _vm._v(
                      "\n                ※" +
                        _vm._s(_vm.errors.first("setting-form.noticeEmail")) +
                        "\n              "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userInfo.noticeEmail,
                      expression: "userInfo.noticeEmail"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "'required|email'"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    "data-vv-as": "メールアドレス",
                    "data-vv-name": "noticeEmail",
                    "data-vv-scope": "setting-form"
                  },
                  domProps: { value: _vm.userInfo.noticeEmail },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.userInfo, "noticeEmail", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group flexbox" }, [
              _c(
                "label",
                {
                  staticClass:
                    "control-label flex-item flex-lable flexbox justify-between label-width-3"
                },
                [_vm._v("売上通知")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-item" },
                [
                  _c("toggle-button", {
                    attrs: {
                      labels: { checked: "ON", unchecked: "OFF" },
                      height: 30,
                      width: 62,
                      sync: true
                    },
                    model: {
                      value: _vm.isNoticeEmail,
                      callback: function($$v) {
                        _vm.isNoticeEmail = $$v
                      },
                      expression: "isNoticeEmail"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "update-btn" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-warning w-120",
                  attrs: { disabled: _vm.disabled },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.updateSetting()
                    }
                  }
                },
                [_vm._v("更新")]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "noti-setting-discription" }, [
      _vm._v("\n          売上通知について設定ができます。"),
      _c("br"),
      _vm._v(
        "\n          ※メールマガジン等の売上通知以外のメールについては、各メールに記載のリンクより変更をお願いします。\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass:
          "control-label flex-item flex-lable flexbox justify-between label-width-3"
      },
      [
        _vm._v("メールアドレス\n              "),
        _c("span", { staticClass: "text-danger m-r-sm" }, [_vm._v("＊")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c23d6fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c23d6fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/Others.vue
// module id = null
// module chunks = 